import { useState, useEffect } from "react";
import { Users, GraduationCap, BookOpen, ClipboardList } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminOverview = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(`${API}/analytics/overview`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (error) {
      console.error("Failed to load stats");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="flex justify-center py-12"><div className="spinner"></div></div>;

  const cards = [
    { label: "Students", value: stats?.total_students || 0, icon: Users, color: "metric-card-mint" },
    { label: "Tutors", value: stats?.total_tutors || 0, icon: GraduationCap, color: "metric-card-yellow" },
    { label: "Courses", value: stats?.total_courses || 0, icon: BookOpen, color: "metric-card-pink" },
    { label: "Enrollments", value: stats?.total_enrollments || 0, icon: Users, color: "metric-card-mint" },
    { label: "Assignments", value: stats?.total_assignments || 0, icon: ClipboardList, color: "metric-card-yellow" },
  ];

  return (
    <div>
      <h1 className="text-3xl font-bold mb-2">Dashboard</h1>
      <p className="text-[#4A4A4A] mb-8">Overview of your language school</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, i) => (
          <div key={i} className={`${card.color} p-6`}>
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm uppercase tracking-wider font-bold text-[#4A4A4A] mb-1">{card.label}</p>
                <p className="text-4xl font-bold">{card.value}</p>
              </div>
              <div className="w-12 h-12 rounded-full bg-white border-2 border-[#0A0A0A] flex items-center justify-center">
                <card.icon className="w-6 h-6" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminOverview;
